import { render, staticRenderFns } from "./NewsFeed.vue?vue&type=template&id=403894de&scoped=true&"
import script from "./NewsFeed.vue?vue&type=script&lang=js&"
export * from "./NewsFeed.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeed.vue?vue&type=style&index=0&id=403894de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403894de",
  null
  
)

export default component.exports